/* =============================================================
   Lont — إصلاح حفظ ملاحظة الطلب (Cart Note)
   -------------------------------------------------------------
   المشكلة الأصلية:
   1) خانة الملاحظة <textarea name="note"> في درج السلة موجودة
      خارج فورم الدفع #CartDrawer-Form، وزرار "إتمام الطلب" بيعمل
      submit للفورم ده. فالملاحظة مبتتبعتش خالص مع الطلب.
   2) الحفظ التلقائي في cart.js بيستنى 300ms بعد آخر حرف، ولو
      العميل دوس الدفع قبل كده الريكوست بيتلغي مع انتقال الصفحة.
   3) زرار "حفظ" جوه النافذة مجرد بيقفلها ومش بيحفظ حاجة.

   الحل هنا:
   1) ربط الـ textarea بفورم السلة عن طريق خاصية form عشان
      الملاحظة تتبعت مع الفورم بشكل أصلي (يشتغل حتى بدون JS).
   2) حفظ فوري عند مغادرة الخانة أو الضغط على "حفظ".
   3) حفظ فوري عند بداية الضغط على زرار الدفع، مع keepalive
      عشان الريكوست يكمّل حتى لو الصفحة اتنقلت.

   الملف ده مستقل تمامًا — مش بيعدل ولا بيعتمد على cart.js،
   فلو اتشال الموضوع بيرجع زي ما كان بالظبط.
   ============================================================= */
(function () {
  'use strict';

  var NOTE = 'textarea[name="note"]';
  var CHECKOUT = '[name="checkout"], .cartCheckout, #CartDrawer-Checkout';
  var lastSaved = null;

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function isNote(el) {
    return el && el.matches && el.matches(NOTE);
  }

  /* (1) اربط خانة الملاحظة بالفورم اللي زرار الدفع بيبعته */
  function linkNoteToForm() {
    var fields = document.querySelectorAll(NOTE);

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.form) continue; /* مربوطة بفورم بالفعل */

      var scope = field.closest('cart-drawer') || document;
      var btn = scope.querySelector(CHECKOUT) || document.querySelector(CHECKOUT);
      if (!btn) continue;

      var formId = btn.getAttribute('form') || (btn.form && btn.form.id);
      if (formId) field.setAttribute('form', formId);
    }
  }

  /* (2) احفظ الملاحظة في السلة */
  function saveNote(force) {
    var field = document.querySelector(NOTE);
    if (!field) return;

    var value = field.value;
    if (!force && value === lastSaved) return;
    lastSaved = value;

    try {
      fetch(updateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: value }),
        keepalive: true
      })['catch'](function (err) {
        console.error('[cart-note] فشل حفظ الملاحظة:', err);
      });
    } catch (err) {
      console.error('[cart-note]', err);
    }
  }

  /* حفظ عند مغادرة الخانة أو تغيّر قيمتها */
  document.addEventListener('focusout', function (e) {
    if (isNote(e.target)) saveNote();
  }, true);

  document.addEventListener('change', function (e) {
    if (isNote(e.target)) saveNote();
  }, true);

  /* اربط الفورم أول ما العميل يدخل الخانة (الدرج بيتعاد رسمه) */
  document.addEventListener('focusin', function (e) {
    if (isNote(e.target)) linkNoteToForm();
  }, true);

  /* حفظ عند الضغط على زرار "حفظ" جوه نافذة الملاحظة */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var saveBtn = e.target.closest('.saveBtn');
    if (saveBtn && saveBtn.closest('cart-note')) saveNote(true);

    /* فتح أي نافذة من نوافذ السلة => أعد الربط بعد الرسم */
    if (e.target.closest('.cart-addon__button')) setTimeout(linkNoteToForm, 0);
  }, true);

  /* (3) حفظ قبل الانتقال لصفحة الدفع */
  function beforeCheckout(e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest(CHECKOUT)) return;
    linkNoteToForm();
    saveNote();
  }

  document.addEventListener('mousedown', beforeCheckout, true);
  document.addEventListener('touchstart', beforeCheckout, { capture: true, passive: true });

  function init() {
    linkNoteToForm();
    var field = document.querySelector(NOTE);
    if (field && lastSaved === null) lastSaved = field.value;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
